let _store: any
function setStore(store) {
  _store = store
}
function getState() {
  return (_store && _store.getState()) || {}
}
function dispatch(action: any) {
  return (_store && _store.dispatch(action)) || {}
}
export default { setStore, getState, dispatch }



// WEBPACK FOOTER //
// ./src/services/store.ts